<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <!-- <v-btn v-if="_hasPerm('project_add')" color="primary" fab small dark @click="onAddNewClicked">
              <v-icon>add</v-icon>
            </v-btn> -->
            <v-spacer></v-spacer>
            <v-layout row wrap>
              <v-flex sm6></v-flex>
              <v-flex sm6>
                <v-text-field
                  v-model="searchTable"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="desserts"
            :pagination.sync="pagination"
            :total-items="totalDesserts"
            :loading="loading"
            class="elevation-1"
            :rows-per-page-items="$CONFIG.tablePG"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.flight_departure }}</td>
                <td>{{ props.item.flight_arrival }}</td>
                <td>{{ props.item.passport_number }}</td>
                <td>{{ props.item.name }}</td>
                <td>
                  <v-menu offset-y transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <v-btn flat icon small color="primary" v-on="on">
                        <v-icon dark>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in rowActionItems"
                        :key="index"
                        @click="onRowActionItemClicked(item.value, props.item)"
                      >
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <v-btn fab bottom right color="pink" dark fixed @click.stop="productsAddModal=true;">
      <v-icon>add</v-icon>
    </v-btn>-->

    <!-- <v-dialog v-model="isAddFormModal" scrollable persistent max-width="900px">
      <AddForm
        :agents="agents"
        :employers="employers"
        @cancelled="isAddFormModal = false"
        @added="getDataFromApi"
      />
    </v-dialog> -->
    <v-dialog v-model="isEditFormModal" scrollable persistent max-width="1000px">
      <EditForm
        :agents="agents"
        :employers="employers"
        @cancelled="isEditFormModal = false"
        :edit-item="editItem"
      />
    </v-dialog>
    <v-dialog v-model="isDetailsModal" scrollable persistent max-width="1000px">
      <DetailsView
        @cancelled="isDetailsModal = false"
        :item="editItem"
        :details="projectDetais"
        @paymentAdded="onPaymentAdded"
        @reload="loadProjectDetails"
      />
    </v-dialog>
  </div>
</template>

<script>
import Nl2br from "vue-nl2br";
import EditForm from "./ProjectFlightEdit";
import DetailsView from "../project/ProjectDetails";

export default {
  components: {
    Nl2br,
    // AddForm,
    EditForm,
    DetailsView,
  },
  data: () => ({
    actionButtonClicked: false,

    headers: [
      { text: "Departure", value: "flight_departure" },
      { text: "Arrival", value: "flight_arrival" },
      { text: "Passport", value: "passport_number" },
      { text: "Candidate Name", value: "name" },
      { text: "Actions", value: "name", sortable: false },
    ],

    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {
      sortBy:'flight_departure',
      descending: false
    },
    getApiaParams: {
      fields: 'id,name,passport_number,flight_airlines,flight_number,flight_departure,flight_arrival,flight_destination,flight_notes',
      search_fields: "id,name,mobile,email,contract_date,passport_number,notes,flight_airlines,flight_number,flight_departure,flight_arrival,flight_destination,flight_notes",
    },

    searchTable: "",

    rowActionItems: [
      { title: "View Details", value: "details" },
      { title: "Edit", value: "edit" },
      // { title: "Delete", value: "delete" },
    ],

    isAddFormModal: false,
    isEditFormModal: false,
    isDetailsModal: false,
    editItem: {},

    agents: [],
    employers: [],
    projectDetais: {},

    selectedItem: {}

    // isPatientPrescriptionsModal: false,
    // selectedPatient: {},
    // patientPrescriptions: [],
    // patientPrescription: {},
    // patientPrescriptionDetails: {},
    // isPreviewPrescripiton: false,
  }),

  computed: {},

  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    searchTable: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {},

  mounted() {},

  methods: {
    getDataFromApi() {
      this.loading = true;
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      if (sortBy == null) {
        delete this.getApiaParams.sort;
      } else {
        this.getApiaParams.sort = descending ? "-" + sortBy : "+" + sortBy;
      }
      this.getApiaParams.limit = rowsPerPage;
      this.getApiaParams.offset = (page - 1) * rowsPerPage;
      this.getApiaParams.search = this.searchTable;

      this.get("/projects", this.getApiaParams).then((response) => {
        this.desserts = response.data.data.items;
        this.totalDesserts = response.data.data.total_items;
        this.loading = false;
      });
    },
    async loadFormData() {
      const agentRes = await this.get("/agents");
      this.agents = agentRes.data.data;
      const employerRes = await this.get("/employers");
      this.employers = employerRes.data.data;
    },
    onAddNewClicked() {
      this.isAddFormModal = true;
      this.loadFormData();
    },
    onEditClicked(item) {
      this.editItem = item;
      this.isEditFormModal = true;
      this.loadFormData();
    },
    onDetailsClicked(item) {
      this.editItem = item;
      this.isDetailsModal = true;
      this.loadProjectDetails();
    },
    async loadProjectDetails() {
      const { id } = this.selectedItem;
      const projectRes = await this.get(`/project_details/${id}`);
      this.projectDetais = projectRes.data;
    },

    onPaymentAdded(addedData){
      // console.log('addedData:', addedData);
      this.loadProjectDetails();
    },

    onRowActionItemClicked(action, item) {
      this.selectedItem = item;
      switch (action) {
        case "details":
          this.onDetailsClicked(item);
          break;
        case "edit":
          this.onEditClicked(item);
          break;
        case "delete":
          this.$confirm("Do you really want to DELETE project ?").then((isConfirmed) => {
            if (isConfirmed) {
              this.$http.delete("/project/" + item.id).then((res) => {
                if (res.data.success) {
                  this.desserts = this.desserts.filter((row) => row.id != item.id);
                }
                this.snackbarShow(res.data);
              });
            }
          });
          break;
      }
    },
  },

  beforeDestroy() {},
};
</script>
